import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    INICIA_ATIVIDADE_PEDAGOGICA,
    SALVA_ATIVIDADE_PEDAGOGICA,
    SALVA_ATIVIDADE_PEDAGOGICA_LOTE,
    REMOVE_ATIVIDADE_PEDAGOGICA,
    BUSCA_ATIVIDADE_PEDAGOGICA_EDICAO,
    LISTA_ATIVIDADE_PEDAGOGICA,
    LISTA_TURMAS_PARA_ATIVIDADE,
    LISTA_ESCOLAS_ATIVIDADE,
    LISTA_CURSOS_ATIVIDADE,
    LISTA_SERIES_ATIVIDADE,
    LISTA_ETAPAS_ATIVIDADE,
    LISTA_DISCIPLINAS_ATIVIDADE,
    LISTA_ALUNOS_TURMA_ATIVIDADE
} from "constants/ActionTypes";
import requisicaoApi from 'util/Api';
import {
    inicioAtividadePedagogicaSucesso,
    listaAtividadePedagogicaSucesso,
    salvaAtividadePedagogicaSucesso,
    removeAtividadePedagogicaSucesso,
    buscaAtividadePedagogicaEdicaoSucesso,
    listaTurmasParaAtividadeSucesso,
    listaEscolasAtividadeSucesso,
    listaCursosAtividadeSucesso,
    listaSeriesAtividadeSucesso,
    listaEtapasAtividadeSucesso,
    listaDisciplinasAtividadeSucesso,
    listaAlunosTurmaAtividadeSucesso,
    salvaAtividadePedagogicaLoteSucesso,
    showMessage,
    showLoader,
    showMessageSuccess,
    showMessageError
} from "actions/AtividadesPedagogicas";

/*#################################################################################################################*/
/* --------------------------------------------- Requests --------------------------------------------------------*/

const getAtividades = async (filtro) =>
    await requisicaoApi.get('/atividades-pedagogicas', { params: filtro })
        .then(resposta => resposta)
        .catch(error => error);

const getAtividadeEdicao = async (id) =>
    await requisicaoApi.get('/atividades-pedagogicas/' + id)
        .then(resposta => resposta)
        .catch(error => error);

const salvaAtividadeRequest = async (atividade) => {
    // Verifica se é FormData
    let id = null;
    if (atividade instanceof FormData) {
        id = atividade.get('id');
        // Suporte para ID dentro de JSON string 'atividade'
        if (!id) {
            const atividadeJson = atividade.get('atividade');
            if (atividadeJson) {
                try {
                    const parsed = JSON.parse(atividadeJson);
                    id = parsed.id;
                } catch (e) { }
            }
        }
    } else {
        id = atividade.id;
    }

    // Se ID > 0 é edição (PUT), senão criação (POST)
    if (id && id > 0) {
        // Para edição, talvez seja necessário ajustar para /atividades-pedagogicas/{id} também
        // Mas o usuário especificou POST /api/atividades-pedagogicas
        // Vamos manter o padrão REST se possível
        return await requisicaoApi.put('/atividades-pedagogicas/' + id, atividade)
            .then(resposta => resposta)
            .catch(error => error);
    } else {
        return await requisicaoApi.post('/atividades-pedagogicas', atividade)
            .then(resposta => resposta)
            .catch(error => error);
    }
};

const removeAtividadeRequest = async (id) =>
    await requisicaoApi.delete('/atividades-pedagogicas/' + id)
        .then(resposta => resposta)
        .catch(error => error);

const getTurmasRequest = async (filtros) => {
    // Busca turmas disponíveis para atribuição com filtros
    // Mapeamento de parâmetros conforme solicitado: Ano, EscolaId, SerieId
    const params = {
        Ano: filtros.anoLetivo,
        EscolaId: filtros.escolaId,
        SerieId: filtros.serieId
    };
    return await requisicaoApi.get('/turmas', { params })
        .then(resposta => resposta)
        .catch(error => error);
};

// Requests Filtros Cascata (Igual NotasFaltas)
const getEscolas = async () =>
    await requisicaoApi.get('/escolas')
        .then(resposta => resposta)
        .catch(error => error);

const getCursosPorEscolaAnoLetivo = async (escolaId, anoLetivo) =>
    await requisicaoApi.get(`/escolas/${escolaId}/cursos`, { params: { anoLetivo } })
        .then(resposta => resposta)
        .catch(error => error);

const getSeriesPorCurso = async (cursoId) =>
    await requisicaoApi.get('/series', { params: { CursoId: cursoId } })
        .then(resposta => resposta)
        .catch(error => error);

const getEtapasAnoLetivo = async (escolaId, anoLetivo) =>
    await requisicaoApi.get(`/escolas/${escolaId}/etapas-ano-letivo`, { params: { anoLetivo } })
        .then(resposta => resposta)
        .catch(error => error);

const getDisciplinasDisponiveis = async (escolaId, serieId, anoLetivo, turmaId) =>
    await requisicaoApi.get('/turmas/disciplinas-disponiveis', { params: { escolaId, serieId, ano: anoLetivo, turmaId } })
        .then(resposta => resposta)
        .catch(error => error);

const getAlunosTurma = async (turmaId) =>
    await requisicaoApi.get(`/turmas/${turmaId}/alunos-cursando`)
        .then(resposta => resposta)
        .catch(error => error);

const salvaAtividadeLoteRequest = async (formData) => {
    return await requisicaoApi.post('/atividades-pedagogicas/lote', formData)
        .then(resposta => resposta)
        .catch(error => error);
};

const extractErrorMessage = (error, mensagemPadrao) => {
    if (!error) return mensagemPadrao;

    const response = error.response;
    const status = response?.status;
    const responseData = response?.data;

    // Se for erro 400 (validação), tentar extrair inconsistências
    if (status === 400 && responseData) {
        const inconsistencias = responseData.inconsistencias || [];
        if (Array.isArray(inconsistencias) && inconsistencias.length > 0) {
            return inconsistencias[0].mensagem || mensagemPadrao;
        }
        if (responseData.mensagem) {
            return responseData.mensagem;
        }
        if (responseData.message) {
            return responseData.message;
        }
    }

    // Tentar outras formas de extrair a mensagem
    if (responseData?.mensagem) return responseData.mensagem;
    if (responseData?.message) return responseData.message;
    if (error.message) return error.message;

    return mensagemPadrao;
};

/*#################################################################################################################*/
/* --------------------------------------------- Sagas -----------------------------------------------------------*/

function* fnListaAtividade({ payload }) {
    try {
        const resposta = yield call(getAtividades, payload);
        if (resposta.status === 200) {
            yield put(listaAtividadePedagogicaSucesso(resposta.data));
        } else {
            yield put(showMessage('Erro ao listar atividades.'));
        }
    } catch (error) {
        yield put(showMessage('Erro de conexão ao listar atividades.'));
    }
}

function* fnSalvaAtividade({ payload }) {
    try {
        const resposta = yield call(salvaAtividadeRequest, payload);
        if (resposta.status === 200 || resposta.status === 201) {
            yield put(salvaAtividadePedagogicaSucesso(resposta.data));
            yield put(showMessageSuccess('Atividade salva com sucesso!'));
            // Recarrega a lista após salvar
            yield call(fnListaAtividade, { payload: {} });
        } else {
            const mensagem = extractErrorMessage(resposta, 'Erro ao salvar atividade');
            yield put(showMessageError(mensagem));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro de conexão ao salvar atividade');
        yield put(showMessageError(mensagem));
    }
}

function* fnRemoveAtividade({ payload }) {
    try {
        const resposta = yield call(removeAtividadeRequest, payload);
        if (resposta.status === 200 || resposta.status === 204) {
            yield put(removeAtividadePedagogicaSucesso(payload));
            yield put(showMessageSuccess('Atividade removida com sucesso!'));
            // Volta para a listagem
            yield call(fnListaAtividade, { payload: {} });
        } else {
            const mensagem = extractErrorMessage(resposta, 'Erro ao remover atividade');
            yield put(showMessageError(mensagem));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro de conexão ao remover atividade');
        yield put(showMessageError(mensagem));
    }
}

function* fnBuscaAtividadeEdicao({ payload }) {
    try {
        const resposta = yield call(getAtividadeEdicao, payload);
        if (resposta.status === 200) {
            yield put(buscaAtividadePedagogicaEdicaoSucesso(resposta.data));
        } else {
            yield put(showMessage('Erro ao buscar atividade para edição.'));
        }
    } catch (error) {
        yield put(showMessage('Erro de conexão ao buscar atividade.'));
    }
}

function* fnIniciaAtividade() {
    // Pode carregar dados iniciais se necessário
    yield put(inicioAtividadePedagogicaSucesso());
    yield call(fnListaAtividade, { payload: {} });
}

function* fnListaTurmas({ payload }) {
    try {
        const resposta = yield call(getTurmasRequest, payload);
        if (resposta.status === 200) {
            const turmas = Array.isArray(resposta.data) ? resposta.data : [];
            yield put(listaTurmasParaAtividadeSucesso(turmas));
        } else {
            // Não bloqueia o fluxo principal com erro de combo, apenas loga ou avisa discreto
            console.error('Erro ao listar turmas');
        }
    } catch (error) {
        console.error('Erro de conexão ao listar turmas', error);
    }
}

// Sagas Filtros Cascata
function* fnListaEscolasAtividade() {
    try {
        const retorno = yield call(getEscolas);
        if (retorno.message || retorno.response) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao buscar escolas');
            yield put(showMessage(mensagem));
        } else {
            const data = retorno.data;
            const escolas = Array.isArray(data) ? data : (Array.isArray(data?.escolas) ? data.escolas : []);
            yield put(listaEscolasAtividadeSucesso(escolas));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao buscar escolas');
        yield put(showMessage(mensagem));
    }
}

function* fnListaCursosAtividade({ payload }) {
    try {
        const { escolaId, anoLetivo } = payload;
        if (!escolaId || Number(escolaId) === 0) {
            yield put(listaCursosAtividadeSucesso([]));
            return;
        }
        const retorno = yield call(getCursosPorEscolaAnoLetivo, escolaId, anoLetivo);
        if (retorno.message || retorno.response) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao listar cursos');
            yield put(showMessage(mensagem));
        } else {
            const data = retorno.data;
            const cursos = Array.isArray(data) ? data : (Array.isArray(data?.cursos) ? data.cursos : (Array.isArray(data?.Cursos) ? data.Cursos : []));
            yield put(listaCursosAtividadeSucesso(cursos));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao listar cursos');
        yield put(showMessage(mensagem));
    }
}

function* fnListaSeriesAtividade({ payload }) {
    try {
        const { cursoId } = payload;
        if (!cursoId || Number(cursoId) === 0) {
            yield put(listaSeriesAtividadeSucesso([]));
            return;
        }
        const retorno = yield call(getSeriesPorCurso, cursoId);
        if (retorno.message || retorno.response) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao listar séries');
            yield put(showMessage(mensagem));
        } else {
            const data = retorno.data;
            const series = Array.isArray(data) ? data : (Array.isArray(data?.series) ? data.series : (Array.isArray(data?.Series) ? data.Series : []));
            yield put(listaSeriesAtividadeSucesso(series));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao listar séries');
        yield put(showMessage(mensagem));
    }
}

function* fnListaEtapasAtividade({ payload }) {
    try {
        const { escolaId, anoLetivo } = payload;
        if (!escolaId || !anoLetivo) {
            yield put(listaEtapasAtividadeSucesso([]));
            return;
        }
        const retorno = yield call(getEtapasAnoLetivo, escolaId, anoLetivo);
        if (retorno.message || retorno.response) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao listar etapas');
            yield put(showMessage(mensagem));
        } else {
            const data = retorno.data;
            // Adaptação: algumas APIs retornam etapas dentro de um objeto ou array direto
            const etapas = Array.isArray(data) ? data : (Array.isArray(data?.etapas) ? data.etapas : []);
            yield put(listaEtapasAtividadeSucesso(etapas));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao listar etapas');
        yield put(showMessage(mensagem));
    }
}

function* fnListaDisciplinasAtividade({ payload }) {
    try {
        const { escolaId, serieId, anoLetivo, turmaId } = payload;
        if (!escolaId || !serieId || !anoLetivo || !turmaId) {
            yield put(listaDisciplinasAtividadeSucesso([]));
            return;
        }
        const retorno = yield call(getDisciplinasDisponiveis, escolaId, serieId, anoLetivo, turmaId);
        if (retorno.message || retorno.response) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao listar disciplinas');
            yield put(showMessage(mensagem));
        } else {
            const data = retorno.data;
            const disciplinas = Array.isArray(data) ? data : (Array.isArray(data?.componentes) ? data.componentes : (Array.isArray(data?.disciplinas) ? data.disciplinas : []));
            yield put(listaDisciplinasAtividadeSucesso(disciplinas));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao listar disciplinas');
        yield put(showMessage(mensagem));
    }
}

function* fnListaAlunosTurmaAtividade({ payload }) {
    try {
        const { turmaId } = payload;
        if (!turmaId) {
            yield put(listaAlunosTurmaAtividadeSucesso([]));
            return;
        }
        const retorno = yield call(getAlunosTurma, turmaId);
        if (retorno.message || retorno.response) {
            const mensagem = extractErrorMessage(retorno, 'Erro ao listar alunos da turma');
            yield put(showMessage(mensagem));
        } else {
            const data = retorno.data;
            const alunos = Array.isArray(data) ? data : [];
            yield put(listaAlunosTurmaAtividadeSucesso(alunos));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro ao listar alunos da turma');
        yield put(showMessage(mensagem));
    }
}

function* fnSalvaAtividadeLote({ payload }) {
    try {
        const resposta = yield call(salvaAtividadeLoteRequest, payload);
        if (resposta.status === 200 || resposta.status === 201) {
            yield put(salvaAtividadePedagogicaLoteSucesso(resposta.data));
            yield put(showMessageSuccess('Atividades em lote salvas com sucesso!'));
            yield call(fnListaAtividade, { payload: {} });
        } else {
            const mensagem = extractErrorMessage(resposta, 'Erro ao salvar atividades em lote');
            yield put(showMessageError(mensagem));
        }
    } catch (error) {
        const mensagem = extractErrorMessage(error, 'Erro de conexão ao salvar atividades em lote');
        yield put(showMessageError(mensagem));
    }
}

/*#################################################################################################################*/
/* ------------------------------------------- Watchers ----------------------------------------------------------*/

export function* listaAtividade() {
    yield takeEvery(LISTA_ATIVIDADE_PEDAGOGICA, fnListaAtividade);
}

export function* salvaAtividade() {
    yield takeEvery(SALVA_ATIVIDADE_PEDAGOGICA, fnSalvaAtividade);
}

export function* removeAtividade() {
    yield takeEvery(REMOVE_ATIVIDADE_PEDAGOGICA, fnRemoveAtividade);
}

export function* buscaAtividadeEdicao() {
    yield takeEvery(BUSCA_ATIVIDADE_PEDAGOGICA_EDICAO, fnBuscaAtividadeEdicao);
}

export function* iniciaAtividade() {
    yield takeEvery(INICIA_ATIVIDADE_PEDAGOGICA, fnIniciaAtividade);
}

export function* listaTurmas() {
    yield takeEvery(LISTA_TURMAS_PARA_ATIVIDADE, fnListaTurmas);
}

export function* listaEscolasAtividade() {
    yield takeEvery(LISTA_ESCOLAS_ATIVIDADE, fnListaEscolasAtividade);
}

export function* listaCursosAtividade() {
    yield takeEvery(LISTA_CURSOS_ATIVIDADE, fnListaCursosAtividade);
}

export function* listaSeriesAtividade() {
    yield takeEvery(LISTA_SERIES_ATIVIDADE, fnListaSeriesAtividade);
}

export function* listaEtapasAtividade() {
    yield takeEvery(LISTA_ETAPAS_ATIVIDADE, fnListaEtapasAtividade);
}

export function* listaDisciplinasAtividade() {
    yield takeEvery(LISTA_DISCIPLINAS_ATIVIDADE, fnListaDisciplinasAtividade);
}

export function* listaAlunosTurmaAtividade() {
    yield takeEvery(LISTA_ALUNOS_TURMA_ATIVIDADE, fnListaAlunosTurmaAtividade);
}

export function* salvaAtividadeLote() {
    yield takeEvery(SALVA_ATIVIDADE_PEDAGOGICA_LOTE, fnSalvaAtividadeLote);
}

/*#################################################################################################################*/
/* ------------------------------------------- Root Saga ---------------------------------------------------------*/

export default function* rootSaga() {
    yield all([
        fork(listaAtividade),
        fork(salvaAtividade),
        fork(salvaAtividadeLote),
        fork(removeAtividade),
        fork(buscaAtividadeEdicao),
        fork(iniciaAtividade),
        fork(listaTurmas),
        fork(listaEscolasAtividade),
        fork(listaCursosAtividade),
        fork(listaSeriesAtividade),
        fork(listaEtapasAtividade),
        fork(listaDisciplinasAtividade),
        fork(listaAlunosTurmaAtividade)
    ]);
}
